import { useEffect } from "react";
import { Navigate, useParams, useNavigate } from "react-router-dom";
import ExperienceShell from "../ExperienceShell";
import { embeddedFunToolRoutes, isAvailableFunTool, withBasePath } from "../routes";
import { createNavigateToFunHandler } from "../utils";

export default function FunToolExperiencePage() {
  const { toolId = "" } = useParams();
  const navigate = useNavigate();
  const toolRoute = embeddedFunToolRoutes[toolId];

  useEffect(() => {
    const handleMessage = createNavigateToFunHandler(navigate);
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [navigate]);

  if (!toolRoute || !isAvailableFunTool(toolId)) {
    return <Navigate to="/experience/fun" replace />;
  }

  return (
    <ExperienceShell activeId="fun" activeFunToolId={toolId} contentKey={`fun-${toolId}`}>
      <div
        className="h-full min-h-[680px] md:min-h-[calc(100vh-132px)] rounded-2xl overflow-hidden border"
        style={{ background: "var(--bg-primary)", borderColor: "var(--border-color)" }}
      >
        <iframe
          key={toolId}
          title={toolId}
          src={withBasePath(toolRoute)}
          className="w-full h-full min-h-[680px] md:min-h-[calc(100vh-132px)] border-0"
        />
      </div>
    </ExperienceShell>
  );
}
